import { render, staticRenderFns } from "./translation.vue?vue&type=template&id=777b0964&"
import script from "./translation.vue?vue&type=script&lang=js&"
export * from "./translation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports